import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { messageComponent } from './message.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { A11yModule } from '@angular/cdk/a11y';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  declarations: [messageComponent],
  providers: [DialogService],
  imports: [TranslateModule, CommonModule, FormsModule, A11yModule, DirectivesModule],
  exports: [messageComponent]
})
export class MessageModule { }
